/**
 * G11 — map contact-policy copy kinds to customer.json i18n keys.
 */
import type {
  ContactIdentifierCopyKind,
  PasswordIdentifierCopyKind,
} from 'pi-kiosk-shared';

export function contactIdentifierLabelKey(
  kind: ContactIdentifierCopyKind,
):
  | 'auth.identifierLabelEmail'
  | 'auth.identifierLabelPhone'
  | 'auth.identifierLabelEmailOrPhone' {
  if (kind === 'phone') {
    return 'auth.identifierLabelPhone';
  }
  if (kind === 'emailOrPhone') {
    return 'auth.identifierLabelEmailOrPhone';
  }
  return 'auth.identifierLabelEmail';
}

export function contactIdentifierPlaceholderKey(
  kind: ContactIdentifierCopyKind,
):
  | 'auth.identifierPlaceholderEmail'
  | 'auth.identifierPlaceholderPhone'
  | 'auth.identifierPlaceholderEmailOrPhone' {
  if (kind === 'phone') {
    return 'auth.identifierPlaceholderPhone';
  }
  if (kind === 'emailOrPhone') {
    return 'auth.identifierPlaceholderEmailOrPhone';
  }
  return 'auth.identifierPlaceholderEmail';
}

export function contactIdentifierHelperKey(
  kind: ContactIdentifierCopyKind,
):
  | 'auth.helperTextEmail'
  | 'auth.helperTextPhone'
  | 'auth.helperTextEmailOrPhone' {
  if (kind === 'phone') {
    return 'auth.helperTextPhone';
  }
  if (kind === 'emailOrPhone') {
    return 'auth.helperTextEmailOrPhone';
  }
  return 'auth.helperTextEmail';
}

export function passwordIdentifierLabelKey(
  kind: PasswordIdentifierCopyKind,
):
  | 'auth.passwordIdentifierLabel'
  | 'auth.passwordIdentifierLabelWithPhone' {
  return kind === 'withPhone'
    ? 'auth.passwordIdentifierLabelWithPhone'
    : 'auth.passwordIdentifierLabel';
}

export function passwordIdentifierPlaceholderKey(
  kind: PasswordIdentifierCopyKind,
):
  | 'auth.passwordIdentifierPlaceholder'
  | 'auth.passwordIdentifierPlaceholderWithPhone' {
  return kind === 'withPhone'
    ? 'auth.passwordIdentifierPlaceholderWithPhone'
    : 'auth.passwordIdentifierPlaceholder';
}

export function passwordHintKey(
  kind: PasswordIdentifierCopyKind,
): 'auth.passwordHint' | 'auth.passwordHintWithPhone' {
  return kind === 'withPhone' ? 'auth.passwordHintWithPhone' : 'auth.passwordHint';
}
